import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for updating a Confluence whiteboard.
 */

/**
 * Properties for the Confluence whiteboard update command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to update a Confluence whiteboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update a Confluence whiteboard with the specified content.
 */
export var ConfluenceWhiteboardUpdateCommand = createCommand('confluence-whiteboard-update-command');